'use client';
import { css } from '@wanteddev/wds-engine';
import { createResponsiveStyle, typographyStyle } from '../../utils/index.mjs';

// src/components/text-area/style.ts
var textAreaWrapperStyle = ({
  disabled,
  invalid,
  width = "fit-content",
  xs,
  sm,
  md,
  lg,
  xl
}) => (theme) => css`
    border: none;
    box-shadow: inset 0 0 0 1px ${theme.palette.line.normal.normal};
    border-radius: 10px;
    background-color: transparent;

    --wds-text-area-max-length-padding-bottom: 16px;
    --wds-text-area-additional-padding-right: 8px;

    ${!invalid && !disabled && css`
      @supports selector(:has(*)) {
        &:where(:has(textarea:focus)) {
          box-shadow: inset 0 0 0 1px ${theme.palette.primary.normal};
        }
      }

      @supports not selector(:has(*)) {
        &:where(:focus-within) {
          box-shadow: inset 0 0 0 1px ${theme.palette.primary.normal};
        }
      }
    `}

    ${disabled && css`
      background-color: ${theme.palette.interaction.disable};
      cursor: default;
    `}

    ${invalid && css`
      box-shadow: inset 0 0 0 1px ${theme.palette.status.negative};
    `}

    width: ${width};

    button {
      flex-shrink: 0;
      transition:
        background-color 0.3s ease,
        color 0.3s ease;
    }

    & > div {
      height: var(--wds-text-area-scroll-height);

      & > div {
        display: block !important;
        height: var(--wds-text-area-height);
        overflow: hidden;
      }
    }

    ${createResponsiveStyle(
  { xs, sm, md, lg, xl },
  theme
)(
  (params) => css`
        ${Boolean(params?.width) && css`
          width: ${params.width};
        `}
      `
)}
  `;
var textAreaStyle = ({ xs, sm, md, lg, xl }) => (theme) => css`
    height: var(--wds-text-area-height);
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 12px 16px;
    flex-shrink: 2;
    background-color: transparent;
    outline: none;
    border: none;
    resize: none;
    color: ${theme.palette.label.normal};
    ${typographyStyle("body1_normal", "regular")}

    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::placeholder {
      ${typographyStyle("body1_normal", "regular")}
      color: ${theme.palette.label.assistive};
    }

    &:focus {
      outline: none;
    }

    ${createResponsiveStyle(
  { xs, sm, md, lg, xl },
  theme
)(
  (params) => css`
        ${Boolean(params?.width) && css`
          width: ${params.width};
        `}

        ${params?.sx}
      `
)}
  `;
var rightIconStyle = css`
  width: fit-content;
  height: 24px;
  align-items: center;
  position: absolute;
  right: 12px;
  bottom: 12px;

  & [wds-component='icon-button'][data-variant='solid'],
  & [wds-component='icon-button'][data-variant='outlined'] {
    margin-right: -4px;
  }

  & [wds-component='text-button'] {
    margin-right: 4px;
    margin-left: 4px;
  }
`;
var maxLengthStyle = css`
  position: absolute;
  width: fit-content;
  height: fit-content;
  left: 16px;
  bottom: 12px;
`;

export { maxLengthStyle, rightIconStyle, textAreaStyle, textAreaWrapperStyle };
